import React from "react";
import { Container, Title } from "./SobreStyles";
import Footer from "../../components/Footer";
import construcao from "../../images/construcao.png";

const Sobre = () => {
  return (
    <>
      <Container>
        <Title></Title>
        <img src={construcao} alt="Em construção" />
      </Container>
      <Footer />
    </>
  );
};

export default Sobre;
